import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import DispatchPoint from "../../models/dispatch-point";

interface DispatchPointCrudAtionsProps {
  dispatchPoint: DispatchPoint;
  onUpdateClick: (_: DispatchPoint) => void;
  onDeleteClick: (_: DispatchPoint) => void;
  isDemo?: boolean;
}

const DispatchPointCrudActions: React.FC<DispatchPointCrudAtionsProps> = ({
  dispatchPoint,
  onUpdateClick,
  onDeleteClick,
  isDemo,
}) => {
  const editButton = (
    <CTooltip content="Editar">
      <CButton
        className="text-white"
        color="warning"
        onClick={() => {
          onUpdateClick(dispatchPoint);
        }}
      >
        <i className="fa fa-pencil"></i>
      </CButton>
    </CTooltip>
  );
  const deleteButton = (
    <CTooltip content="Eliminar">
      <CButton
        className="text-white"
        color="danger"
        onClick={() => {
          onDeleteClick(dispatchPoint);
        }}
      >
        <i className="fa fa-trash"></i>
      </CButton>
    </CTooltip>
  );

  return (
    <td className="text-center">
      <CButtonGroup>
        {!isDemo && editButton}
        {!isDemo && deleteButton}
      </CButtonGroup>
    </td>
  );
};

export default DispatchPointCrudActions;
